import type { DocumentRepository } from "../repositories/document-repository"

export const makeGetDocuments = (repo: DocumentRepository) =>
  (params: { kbId: string; page: number; limit: number }) =>
    repo.list(params)
